import axios from "axios";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const EcapTemplateService = {
    list: (filter) => axios.post(API_KEEPER + "/ecap/list", filter).then(({ data }) => data).catch((err) => { throw err }),

    get: async (id) => axios.get(API_KEEPER + "/ecap?id=" + id.replace("-", "/")).then(({data}) => data).catch((err) => { throw err }),

    create: async (formData) => axios.post(API_KEEPER + "/ecap", formData).then(({data}) => data).catch((err) => { throw err }),

    update: async (formData) => axios.put(API_KEEPER + "/ecap", formData).then(({data}) => data).catch((err) => { throw err }),

    delete: async (id) => axios.delete(API_KEEPER + "/ecap?id=" + id.replace("-", "/")).catch((err) => { throw err }),

    findPassage: async (processID, dhCapture) => axios.get(API_KEEPER + `/ecap/passage-image/${processID}/${dhCapture}`).then(({data}) => data).catch((err) => { throw err }),
};

export default EcapTemplateService;